import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { loginGuestAccount } from "../../store/actions";
import styles from "./InvitePage.module.scss";

const InvitePage = ({ loginGuestAccount }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const redirectParam = searchParams.get("redirect");
  const redirect = redirectParam && redirectParam.startsWith("/")
    ? redirectParam
    : "/dashboard";

  useEffect(() => {
    loginGuestAccount()
      .then(() => navigate(redirect))
      .catch((error) => console.error("Login error:", error));
  }, [loginGuestAccount, navigate, redirect]);

  return (
    <div className={styles.inviteContainer}>
      <p className={styles.inviteText}>
        Ingresando como invitado
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
        <span className={styles.dot}>.</span>
      </p>
    </div>
  );
};

export default connect(null, { loginGuestAccount })(InvitePage);
